import { FC, ImgHTMLAttributes, useEffect, useState } from 'react';

import { fileBucketUrl } from '@shared/utils/fileUtils';

//* 버킷 이미지 <img> — 축소본(w1080 등)으로 요청하고, 파생본이 없어 404면 원본(raw)으로 1회 폴백.
//* 축소본은 업로드 파이프라인이 만든 파생 파일이라 파이프라인 이전에 올라간 옛 파일엔 없을 수 있다
//* (BucketImage와 같은 이유). 구매자 화면용이라 antd Image(확대 미리보기) 없이 가볍게 둔다.
interface Props extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  /** 버킷 키 */
  value: string;
  /** 축소본 크기 (기본 w1080 — 폰 해상도에서 상세 이미지로 충분) */
  size?: string;
}

export const BucketImg: FC<Props> = function BucketImg({
  value,
  size = 'w1080',
  onError,
  ...rest
}) {
  const [useRaw, setUseRaw] = useState(false);
  //* 키가 바뀌면 폴백 상태 초기화(캐러셀 재사용)
  useEffect(() => setUseRaw(false), [value]);
  return (
    <img
      {...rest}
      src={fileBucketUrl(value, useRaw ? 'raw' : size)}
      onError={(e) => {
        if (!useRaw) setUseRaw(true);
        onError?.(e);
      }}
    />
  );
};
